var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 180,
    viewBox: "0 0 181 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.677 104.743C14.2966 98.2086 14.2967 81.7914 25.6771 75.2572L110.285 26.6785C121.619 20.1714 135.75 28.3528 135.75 41.4213L135.75 138.579C135.75 151.647 121.619 159.829 110.285 153.321L25.677 104.743Z",
    fill: "url(#paint0_linear_1358_8593)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.323 75.2573C166.703 81.7914 166.703 98.2086 155.323 104.743L70.7147 153.321C59.3814 159.829 45.25 151.647 45.25 138.579L45.25 41.4213C45.25 28.3527 59.3814 20.1714 70.7147 26.6785L155.323 75.2573Z",
    fill: "url(#paint1_linear_1358_8593)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1358_8593",
    x1: 0.00000107324,
    y1: 90,
    x2: 181,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.383559,
    stopColor: "#7E0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1358_8593",
    x1: 181,
    y1: 90,
    x2: 0.0000112953,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.273454fc49c0d7b4e678c3c9ab4f08a1.svg";
export { ForwardRef as ReactComponent };